export default "__VITE_ASSET__BBJAbT$o__"